import React from 'react'
import useDataLayer from 'src/hooks/useDataLayer/dataLayerBody'

import ImageWebp from 'src/components/ImageWebp'
import * as S from './style'

const EmprestimoPessoalEFinanciamentoImobiliario = () => {
  const [ sendDatalayerEvent ] = useDataLayer()

  return (
    <S.ContentHeader className='row justify-content-center align-items-center'>
      <div className='col-12 col-md-5 offset-md-1 order-md-last mb-4 mb-md-0'>
        <ImageWebp
          arrayNumbers={[ 312, 276, 325, 407 ]}
          arrayNumbersHeight={[ 312, 276, 325, 420 ]}
          pathSrc='https://central-imagens.bancointer.com.br/images-without-small-versions/dobra6-img2-cartoes/image.webp'
          altDescription='Familia feliz com seu novo imovel.'
          className='float-lg-right'
        />
      </div>
      <div className='col-12 col-md-6 col-xl-5'>
        <h3 className='fs-24 lh-30 fs-lg-32 lh-lg-40 fs-xl-48 lh-xl-50 text-grayscale--500 fw-600 d-block mb-3'>
          Empréstimo Pessoal e Financiamento Imobiliário
        </h3>
        <p className='fs-14 lh-17 fs-lg-16 lh-lg-20 fs-xl-18 lh-xl-22 fw-400 text-grayscale--400 mb-0'>
          De Financiamento Imobiliário a Antecipação de FGTS. Você solicita um empréstimo do seu jeito e de forma simples, segura e transparente.
        </p>
        <div className='btn-div'>
          <a
            href='https://inter.co/credito-pessoal-e-credito-imobiliario/'
            target='_blank'
            rel='noreferrer'
            title='Ver as opções de empréstimos'
            className='btn btn--lg btn-orange--extra rounded-2 fs-14 fw-600 text-none mw-100'
            onClick={() => {
              sendDatalayerEvent({
                section: 'dobra_07',
                section_name: 'Mais que um banco digital, somos Inter!',
                element_action: 'click button',
                element_name: 'Ver as opções de empréstimos - Empréstimo Pessoal e Financiamento Imobiliário',
                redirect_url: 'https://inter.co/credito-pessoal-e-credito-imobiliario/',
              })
            }}
          >
            Ver as opções de empréstimos
          </a>
        </div>
      </div>
    </S.ContentHeader>
  )
}

export default EmprestimoPessoalEFinanciamentoImobiliario
